import { Button, Flex, notification, Space } from "antd";
import React, { useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { addTask } from "../../../service";
import { AddOrderModal } from "../../organisms";
import { GlobalActions } from "../global-actions/GlobalActions";
import TaskCalendarModal from "../task-calendar-modal/TaskCalendarModal";

export const TaskListHeader: React.FC<{
  hardcodedControls: any;
  total: any;
  global_actions: any;
}> = ({ hardcodedControls, total, global_actions }) => {
  const queryClient = useQueryClient();
  const [open, setOpen] = useState(false);

  const { mutateAsync, isLoading } = useMutation(addTask, {
    onSuccess: async () => {
      try {
        await queryClient.refetchQueries("/tasks");
        notification.success({
          message: "Zapisano zmiany",
          style: {
            background: "#52c41a30",
          },
        });
      } catch (error) {
        notification.success({
          message: "Zapisano zmiany",
          style: {
            background: "#52c41a30",
          },
        });
        notification.error({
          message: "Pobierania nowych danych",
          style: {
            background: "#ff4d4f30",
          },
        });
        console.error("Wystąpił błąd podczas odświeżania danych:", error);
      }
    },

    onError: () => {
      notification.error({
        message: "Błąd zapisu danych",
        style: {
          background: "#ff4d4f30",
        },
      });
    },
  });
  return (
    <>
      <AddOrderModal
        open={open}
        setOpen={setOpen}
        mutateAsync={mutateAsync}
        isLoading={isLoading}
        hardcodedControls={hardcodedControls}
      />
      <Flex
        style={{
          paddingBottom: "8px",
        }}
        justify="end"
      >
        <Space>
          <TaskCalendarModal/>
          <GlobalActions total={total} global_actions={global_actions} />
        </Space>
      </Flex>
    </>
  );
};
